import './account/account'
import './account/parts/account/account'
import './auth/auth'
import './docs/parts/content/content'
import './integrations/parts/content-block/content-block'
import './main/parts/mainBanner/mainBanner'
import './main/parts/needUpdate/needUpdate'
import './main/parts/partners/partners'
import './support/parts/support-form/support-form'

import './evolution/parts/mainBanner/mainBanner'
